import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { TypesOfLeavesDto } from './types-of-leaves.dto';


export class TypesOfLeavesResponseModel extends GlobalResponseObject{
    data?: TypesOfLeavesDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: TypesOfLeavesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}